import { rest } from 'msw'
import { ForgotPasswordResponse, ResetPasswordResponse } from 'types/passwords'

const API_URL = process.env.API_URL ?? 'https://jestjs.io'

const postResetPassword = rest.post<ResetPasswordResponse>(
  `${API_URL}/api/user/forgot/confirm`,
  async (req, res, ctx) => {
    return res(ctx.json(200))
  }
)

export const postForgotPassword = rest.post<ForgotPasswordResponse>(
  `${API_URL}/api/user/forgot/request`,
  async (req, res, ctx) => {
    return res(ctx.delay(100), ctx.json(200))
  }
)

export const forgotPasswordServerError = rest.post(
  `${API_URL}/api/user/forgot/request`,
  async (_req, res, ctx) => res(ctx.status(500))
)

export const forgotPasswordRateLimited = rest.post(
  `${API_URL}/api/user/forgot/request`,
  async (_req, res, ctx) => res(ctx.status(429))
)

export default [postResetPassword, postForgotPassword]
